const parseLocalStorageArray = (key) => {
  try {
    const parsedValue = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch {
    return [];
  }
};

export const getCachedSmsTemplates = () => parseLocalStorageArray('referral_sms_template');

export const getCachedReferralReplyTemplates = () => parseLocalStorageArray('referral_reply_templates');

// Availability checks (does this org have any usable reply template?) must not
// count archived templates — an org whose every template is archived should not
// see the Reply action at all. The full cached list (above) is still what the
// reply modal loads, so a historical resend can label its archived template.
// `!== false` keeps cached payloads from before the archive feature working.
export const getActiveCachedReferralReplyTemplates = () => getCachedReferralReplyTemplates()
  .filter((template) => template && template.active !== false);

export const getCachedReferralCallTemplates = () => parseLocalStorageArray('referral_call_templates');

export const getCachedDepartmentIds = () => parseLocalStorageArray('departments')
  .map((department) => department && department.id)
  .filter((departmentId) => departmentId !== undefined && departmentId !== null);

export const getVisibleSmsTemplatesForCurrentUser = () => {
  const userDepartmentIds = getCachedDepartmentIds();

  return getCachedSmsTemplates().filter((template) => template && (
    template.owner_type === 'Organization'
      || (template.owner_type === 'Department' && userDepartmentIds.includes(template.owner_id))
  ));
};
